import { Route, Routes, useNavigate } from "react-router-dom";
import Login from "../Pages/auth/Login";
import ForgotPassword from "../Pages/auth/ForgotPassword";
import ResetPassword from "../Pages/auth/ResetPassword";
import Footer from "../components/Layout/Footer";
import { useEffect } from "react";
import Companies from "../Pages/companies/companies-main/Companies";
import MainHeader from "../components/Layout/MainHeader";
import { whoAmI } from "../redux/auth/authCrud";
import DeletedCompanies from "../Pages/companies/deleted-companies/DeletedCompanies";
import CompanyOverview from "../Pages/company/companyOverview/CompanyOverview";
import Content from "../Pages/content/Content";
import ContenDetails from "../Pages/content/ContentDetails";
import HelpDetails from "../Pages/content/HelpDetails";
import Dashboard from "../Pages/dashboard/Dashboard";

function AppRoutes() {
  const navigate = useNavigate();
  useEffect(() => {
    whoAmI()
      .then(() => {
        if (
          window.location.pathname === "/" ||
          window.location.pathname.includes("forgot-password") ||
          window.location.pathname.includes("reset-password")
        )
          navigate("/companies");
      })
      .catch(() => {
        if (!window.location.pathname.includes("forgot-password") && !window.location.pathname.includes("reset-password")) {
          navigate("/");
        }
      });
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {window.location.pathname.includes("companies") ||
      window.location.pathname.includes("company") ||
      window.location.pathname.includes("dashboard") ||
      window.location.pathname.includes("content") ? (
        <MainHeader />
      ) : null}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/deleted-companies" element={<DeletedCompanies />} />
        <Route path="/company/:id" element={<CompanyOverview />} />
        <Route path="/content" element={<Content />} />
        <Route path="/content/:section/:id" element={<ContenDetails />} />
        <Route path="/content/help/:section/:id" element={<HelpDetails />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* <Route path="/view-invoice/:id" element={<ViewInvoice />} /> */}
      </Routes>
      {window.location.pathname.includes("companies") ||
      window.location.pathname.includes("company") ||
      window.location.pathname.includes("dashboard") ||
      window.location.pathname.includes("content") ? (
        <Footer />
      ) : null}
    </>
  );
}

export default AppRoutes;
